import Tracker from "./components/tracker/Tracker";
import { I18nProvider } from "./i18n/I18nProvider";

function App() {
  return (
    <I18nProvider>
      <Tracker />
    </I18nProvider>
  );
}

export default App;
